interface Member {
  name?: string;
  cell_phone?: string;
  [key: string]: unknown;
}

/**
 * Validates member data for phone number requirements and duplicates
 * @param members - Array of member objects with name and cell_phone properties
 * @returns Error message if validation fails, null if validation passes
 */
export const validateMemberPhoneNumbers = (members: Member[]): string | null => {
  const membersHash: Record<string, Member> = {};
  let formError: string | null = null;

  // Remove the last entry if it's an empty placeholder
  const truncatedMembers = members.slice(0, members.length - 1);

  truncatedMembers.forEach(member => {
    // Check for missing phone numbers
    if (!member.cell_phone) {
      formError = `${member.name} is missing a phone number. All members must have phone numbers`;
    }
    // Check for duplicate phone numbers
    else if (membersHash[member.cell_phone]) {
      formError = `${member.name} and ${membersHash[member.cell_phone].name} have the same phone number. Phone numbers must be unique`;
    }

    // Only add to hash if cell_phone is defined
    if (member.cell_phone) {
      membersHash[member.cell_phone] = member;
    }
  });

  return formError;
};
